import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[960px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100 rounded-full mb-3">
            爆料必读
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于911黑料网你想知道的一切</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item) => (
            <details
              key={item.id}
              className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}